<template>
	<div class="home">
		<a-breadcrumb>
			<a-breadcrumb-item href="">
				<a-icon type="home" />
			</a-breadcrumb-item>
			<a-breadcrumb-item href="">
				<a-icon type="schedule" />
				<span>预约服务</span>
			</a-breadcrumb-item>
			<a-breadcrumb-item> 纸币兑换硬币 </a-breadcrumb-item>
		</a-breadcrumb>

		<div class="search-list-box">
			<a-form class="ant-advanced-search-form">
				<a-row :gutter="24">
					<a-col :span="7">
						<a-form-item :label="`登录账号：`">
							<a-input style="width:100%" v-model="searchData.nike_name" placeholder="请输入登录账号"></a-input>
						</a-form-item>
					</a-col>
					<a-col :span="7">
						<a-form-item :label="`姓名：`">
							<a-input v-model="searchData.real_name" placeholder="请输入姓名"></a-input>
						</a-form-item>
					</a-col>
					<a-col :span="7">
						<a-form-item :label="`手机号码：`">
							<a-input v-model="searchData.mobile" placeholder="请输入手机号码"></a-input>
						</a-form-item>
					</a-col>

					<a-col :span="7">
						<a-form-item :label="`提交时间：`">
							<a-range-picker :key="pickerKey" :disabledDate="disabledDate" :ranges="{ '今天': [moment(), moment()] }" @change="handleChangeDate" style="width: 120px" format="YYYY-MM-DD" />
						</a-form-item>
					</a-col>

					<a-col :span="6" :style="{
              textAlign: 'left',
              paddingLeft: '25px',
              marginTop: '6px',
            }">
						<a-button type="primary" @click="getList"> 查询 </a-button>
						<a-button :style="{ marginLeft: '8px' }" @click="handleReset">
							重置
						</a-button>
					</a-col>
				</a-row>
			</a-form>
			<div class="search-result-list">

				<div class="table-header-box">
					<div class="left">
						<h3 class="title">纸币兑换硬币列表</h3>
					</div>
					<div class="right">
						<a-button type="primary" class="marginr20" @click="showDetail">
							详情
						</a-button>
					</div>
				</div>
				<a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :columns="columns" @change="handleTableChange"
				 :pagination="{total: total_page * 10}" :data-source="list" rowKey="order_id" size="small">
					<span slot="date" slot-scope="date, info">
						{{info.reserve_date}} {{info.reserve_time}}
					</span>
					<span slot="cz" slot-scope="date, info">
						<a v-if="info.status == 1" @click="sh(info)">审核</a>
					</span>
				</a-table>
			</div>
		</div>

		<a-modal v-model="detailShow" title="详细信息" :footer="null">
			<a-spin :spinning="detailLoading">
				<a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" style="margin: 0 auto; width: 100%">
					<a-form-item label="登录账号：">
						<a-input v-model="info.user.nike_name" :disabled="true" />
					</a-form-item>
					<a-form-item label="姓名：">
						<a-input v-model="info.user.real_name" :disabled="true" />
					</a-form-item>
					<a-form-item label="手机号码：">
						<a-input v-model="info.user.mobile" :disabled="true" />
					</a-form-item>
					<a-form-item label="预约1角数量:">
						<a-input v-model="info.coin10" :disabled="true" />
					</a-form-item>
					<a-form-item label="预约5角数量:">
						<a-input v-model="info.coin50" :disabled="true" />
					</a-form-item>
					<a-form-item label="预约1元数量:">
						<a-input v-model="info.coin100" :disabled="true" />
					</a-form-item>
					<a-form-item label="预约状态：">
						<a-input v-model="info.status_txt" :disabled="true" />
					</a-form-item>
					<a-form-item label="提交时间：">
						<a-input v-model="info.add_time" :disabled="true" />
					</a-form-item>
				</a-form>
				<div class="model-footer">
					<div class="left">
						<a-button type="primary" class="marginr20" html-type="submit" @click="detailShow = false">
							取消
						</a-button>
					</div>
					<div class="right">
						<a-button type="dashed" :disabled="isEditBtn('prev')" @click="editToData('prev')" class="" html-type="submit">
							上一条
						</a-button>
						<a-button type="dashed" :disabled="isEditBtn('next')" @click="editToData('next')" class="marginr20" html-type="submit">
							下一条
						</a-button>
					</div>
				</div>
			</a-spin>
		</a-modal>

	</div>
</template>

<script>
	import moment from 'moment';
	import http from '../http'

	const columns = [{
			title: "ID",
			dataIndex: "order_id",
			key: "31"
		},
		{
			title: "姓名",
			dataIndex: "real_name",
			key: "33"
		},
		{
			title: "手机号码",
			dataIndex: "mobile",
			key: "2"
		},
		{
			title: "预约1角数量",
			dataIndex: "coin10",
			key: "131",
			align: 'center'
		},
		{
			title: "预约5角数量",
			dataIndex: "coin50",
			key: "132",
			align: 'center'
		},
		{
			title: "预约1元数量",
			dataIndex: "coin100",
			key: "133",
			align: 'center'
		},
		{
			title: "预约状态",
			dataIndex: "status_txt",
			key: "134"
		},
		{
			title: "提交时间",
			dataIndex: "add_time",
			key: "124"
		},
		{
			title: "操作",
			scopedSlots: {
				customRender: 'cz'
			},
			key: "12214"
		},
	];
	export default {
		data() {
			return {
				expand: false,
				columns,

				detailShow: false,

				info: {
					user: {}
				},

				searchData: {
					page: 1,
					type: 1,
					real_name: '',
					nike_name: '',
					mobile: '',
					start_date: '',
					end_date: ''
				},
				list: [],
				total_page: 0,

				// 表格选择的数据, 存储的是id
				selectedRowKeys: [],
				// 存储的是数据
				selectedRowDataList: [],
				// 当前是第几条编辑信息
				editIndex: 0,

				detailLoading: false,

				pickerKey: Math.random()
			};
		},
		mounted() {
			this.getList()
		},
		methods: {
			moment,
			disabledDate(current) {
			     return current && current >= moment().subtract("days"); //当天之前的不可选，不包括当天
			   //return current && current < moment().endOf(‘day’);当天之前的不可选，包括当天
			},
			sh (data) {
				http({
					method: 'post',
					url: '/api.order.tocheck/',
					data: {
						order_id: data.order_id,
						status: 2
					}
				}).then((res) => {
					if (res.code == '200') {
						this.$message.success('审核成功');
						this.getList()
					} else {
						this.$message.error(res.data);
					}
				})
			},
			handleReset() {
				this.pickerKey = Math.random()
				this.searchData = {
					page: 1,
					type: 1,
					real_name: '',
					nike_name: '',
					mobile: '',
					start_date: '',
					end_date: ''
				}
				this.getList();
			},

			handleSelectChange(value) {
				console.log(value);
				this.form.setFieldsValue({
					note: `Hi, ${value === 'male' ? 'man' : 'lady'}!`,
				});
			},
			// 表格分页
			handleTableChange(pagination, filters, sorter) {
				console.log(pagination, filters, sorter)
				this.searchData.page = pagination.current
				this.getList();
			},
			// 表格选择
			onSelectChange(selectedRowKeys) {
				console.log('selectedRowKeys changed: ', selectedRowKeys);
				this.selectedRowKeys = selectedRowKeys;
			},
			// 列表
			getList() {
				http({
					method: 'post',
					url: '/api.order.list/',
					data: this.searchData
				}).then((res) => {
					this.list = res.data.list
					this.total_page = res.data.total_page
				})
			},
			// 日期解析
			handleChangeDate(date) {
				this.searchData.start_date = this.moment(date[0]).format('YYYY-MM-DD')
				this.searchData.end_date = this.moment(date[1]).format('YYYY-MM-DD')
			},

			showDetail() {
				// 判断是否已经选择数据
				if (this.selectedRowKeys.length == 0) {
					this.$message.warning('请先选择预约');
					return
				}
				console.log(this.selectedRowKeys)
				let selectDatas = []
				this.list.forEach((v) => {
					if (this.selectedRowKeys.includes(v.order_id)) {
						selectDatas.push(v)
					}
				})
				this.selectedRowDataList = JSON.parse(JSON.stringify(selectDatas))
				console.log(this.selectedRowDataList)
				this.editIndex = 0
				// 获取文章详情
				this.getDetail()
				this.detailShow = true
			},
			// 详情
			getDetail() {
				this.detailLoading = true
				http({
					method: 'post',
					url: '/api.order.detail/',
					data: {
						order_id: this.selectedRowDataList[this.editIndex].order_id
					}
				}).then((res) => {
					this.info = res.data
					this.detailLoading = false
				})
			},
			// 点击上一条 或者 下一条、
			editToData(type) {
				let index = -1
				if (type == 'prev') {
					index = this.editIndex - 1
					if (index == 0) {
						index = 0
					}
				} else if (type == 'next') {
					index = this.editIndex + 1
				}
				this.editIndex = index
				this.getDetail()
			},
			// 判断是否可以点击上一条 或者 下一条、
			isEditBtn(type) {
				if (type == 'prev') {
					if (this.editIndex == 0) {
						return true
					}
					if (this.selectedRowDataList == 1) {
						return true
					}
					if (this.editIndex >= 1) {
						return false
					}
				} else if (type == 'next') {
					if ((this.selectedRowDataList.length - 1) == this.editIndex) {
						return true
					}
				}
			},
		},
	};
</script>
<style>
	.ant-advanced-search-form {
		padding: 24px;
		background: #fbfbfb;
		border: 1px solid #d9d9d9;
		border-radius: 6px;
	}

	.ant-advanced-search-form .ant-form-item {
		display: flex;
	}

	.ant-advanced-search-form .ant-form-item-control-wrapper {
		flex: 1;
	}

	.search-list-box .ant-form {
		max-width: none;
	}

	.search-list-box .search-result-list {
		margin-top: 16px;
		border: 1px dashed #e9e9e9;
		border-radius: 6px;
		background-color: #fafafa;
		min-height: 200px;
		text-align: center;
		padding-top: 80px;
	}

	.imgs {
		display: flex;
	}

	.imgs img {
		width: 140px;
		height: 200px;
	}
</style>
